import type { KambiGroup } from '@mobi/api-types/kambi'
import { simpleFetch } from '@mobi/utils/fetch/simpleFetch'

export function getEventGroupsFromRoot() {
  return simpleFetch<GetEventGroupsFromRootResponse>(`${window._kc.apiOfferingBaseUrl}group`)
}

export function getEventGroupByGroupId(groupId: number) {
  return simpleFetch<{ group: KambiGroup }>(`${window._kc.apiOfferingBaseUrl}group/${groupId}`)
}

export function getGroupHighlights() {
  return simpleFetch<{ groups: KambiGroup[] }>(`${window._kc.apiOfferingBaseUrl}group/highlight`)
}

// =====
// Types
// =====

type GetEventGroupsFromRootResponse = {
  group: { boCount: number; eventCount: number; groups: KambiGroup[]; id: 1 }
}
